module.exports = __webpack_public_path__ + "static/media/battery_eng_02.cbf4d902.png";